module.exports = __webpack_public_path__ + "static/media/bagel_offer.f3f47d41.svg";